import { lazy, memo, useCallback, useContext, useEffect } from "react";
import { isMobile } from "react-device-detect";
import "react-loading-skeleton/dist/skeleton.css";
import ApiContact from "../../../core/api/api.contact";
import ContextApp from "../../../core/contexts/context.app";
//import ApiAuth from "../../../core/api/api.auth";


const MobileFooter = lazy(() => import("./MobileFooter"));
const DesktopFooter = lazy(() => import("./DesktopFooter"));

function FooterNav() {
  const ctx = useContext(ContextApp);

  const getData = useCallback(async function () {
    try {
      const contactInfo = await ApiContact.getInfos();
      const contactInfoContent = JSON.parse(contactInfo?.content || []);
      ctx.setPageContent(contactInfoContent)
    } catch {
    }
  }, [ApiContact])


  useEffect(() => {
    getData();
  }, []);
  return (
    <footer>
      {/* ***** mobile ******************************************* */}
      {isMobile ? (
        <MobileFooter />
      ) : (
        // ***** desktop *******************************************
        <DesktopFooter />
      )}
    </footer>
  );
}
export default memo(FooterNav);

